// extracted by mini-css-extract-plugin
export default {"pos-device-connection-successful-form":"x1v4iz","posDeviceConnectionSuccessfulForm":"x1v4iz"};